export const createResizeListener = () => {
    const root = document.getElementById("vroot");
    const debounceTime = 50;
    let timeout = 0;
    const onResize = () => {
        if (!root) {
            return;
        }
        clearTimeout(timeout);
        timeout = window.setTimeout(() => {
            root.style.width = `${window.innerWidth}px`;
            root.style.height = `${window.innerHeight}px`;
        }, debounceTime);
    };
    window.addEventListener("resize", onResize);
    onResize();
};
